/**
 * business.ts — canonical NAP (Name, Address, Phone).
 *
 * Every NAP mention on the site imports from here. No string literals
 * elsewhere. Changes here propagate to: footer, contact page, Organization
 * JSON-LD, email templates, email signatures. NAP consistency test
 * (Playwright) verifies character-for-character match across routes.
 *
 * Per BUSINESS_PROFILE.md §3.
 */
export const business = {
  name: "NEXIRT",
  legalName: "NEXIRT",
  tagline: "Custom software, built like it's meant to last.",
  address: {
    street: "5380 Cameron St",
    city: "Las Vegas",
    region: "NV",
    postalCode: "89118",
    country: "US",
    countryName: "USA",
  },
  contact: {
    email: "contact@nexirt.com",
    salesEmail: "hello@nexirt.com",
    supportEmail: "support@nexirt.com",
    phone: null as string | null,
  },
  hours: {
    timezone: "America/Los_Angeles",
    schedule: [
      { day: "Mon", open: "09:00", close: "18:00" },
      { day: "Tue", open: "09:00", close: "18:00" },
      { day: "Wed", open: "09:00", close: "18:00" },
      { day: "Thu", open: "09:00", close: "18:00" },
      { day: "Fri", open: "09:00", close: "18:00" },
      { day: "Sat", open: null, close: null },
      { day: "Sun", open: null, close: null },
    ] as Array<{ day: string; open: string | null; close: string | null }>,
  },
  founded: "2026",
  social: {
    twitter: null as string | null,
    linkedin: null as string | null,
    github: null as string | null,
  },
} as const;

export const addressOneLine = `${business.address.street}, ${business.address.city}, ${business.address.region} ${business.address.postalCode}, ${business.address.countryName}`;
export const cityStateZip = `${business.address.city}, ${business.address.region} ${business.address.postalCode}`;
